import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AIPersona } from 'types/ai-persona';
import { RepPage } from 'types/rep-page';

export const initialState = {
  aiPersona: null as AIPersona | null,
  repPage: null as RepPage | null,
};

export type RepOnboardingState = typeof initialState;

const repOnboardingSlice = createSlice({
  name: 'repOnboarding',
  initialState,
  reducers: {
    setAiPersona(state, action: PayloadAction<AIPersona>) {
      state.aiPersona = action.payload;
    },
    setRepPage(state, action: PayloadAction<RepPage>) {
      state.repPage = action.payload;
    },
    resetRepOnboarding(state) {
      state.aiPersona = null;
      state.repPage = null;
    },
  },
});

export const {
  setAiPersona,
  setRepPage,
  resetRepOnboarding,
} = repOnboardingSlice.actions;
export default repOnboardingSlice.reducer;
